module.exports = __webpack_public_path__ + "static/media/close_.c4faf7c0.svg";